import { ActionButton, Avatar, TableComponent, TableLoader } from "components";

import { LocationGenerics } from "router/location";
import clsx from "clsx";
import { message } from "antd";
import { useMatch } from "react-location";
import { useOfferParticipantAssociates } from "hooks/data/use-offers";
import { withPermissions } from "utils";

export default function OfferAssociates() {
  const { params } = useMatch<LocationGenerics>();
  const { loading, associates, refetch } = useOfferParticipantAssociates({
    offerId: params.endorsement || "",
  });

  return (
    <div className="grid grid-cols-3 items-start px-3 flex-1">
      <div className="col-span-3">
        <TableComponent
          title={"associates"}
          hasSearch
          loading={loading}
          columns={[
            {
              accessor: "reinsurer_representative.reinsurer.re_company_name",
              name: "Company",
              render: (row) => (
                <div className="flex space-x-2 items-start">
                  <Avatar
                    alt={
                      row?.reinsurer_representative?.reinsurer
                        ?.re_company_name || ""
                    }
                  />
                  <div className="flex flex-col">
                    <span className="font-bold text-xs">
                      {
                        row?.reinsurer_representative?.reinsurer
                          ?.re_company_name
                      }
                    </span>
                    <span className="font-light text-xs">
                      {
                        row?.reinsurer_representative?.reinsurer
                          ?.re_company_email
                      }
                    </span>
                  </div>
                </div>
              ),
            },
            {
              accessor: "reinsurer_representative.rep_first_name",
              name: "Associate",
              render: (row) => (
                <div className="flex flex-col">
                  <span className="font-bold text-xs">
                    {row?.reinsurer_representative?.rep_first_name}{" "}
                    {row?.reinsurer_representative?.rep_last_name}
                  </span>
                  <span className="font-light text-xs">
                    {row?.reinsurer_representative?.rep_email}
                  </span>
                </div>
              ),
            },

            {
              accessor: "sent_status",
              name: "Email Status",
              render: (row) => (
                <>
                  <span
                    className={clsx("p-0.5 px-2 text-xs rounded-full", {
                      "bg-red-100 text-red-500": row?.sent_status === "UNSENT",
                    })}
                  >
                    {row?.sent_status || "N/A"}
                  </span>
                </>
              ),
            },
            {
              accessor: "",
              name: "Actions",
              render: (row) => (
                <>
                  {withPermissions([
                    "*:*",
                    "endorsements:*",
                    "endorsements:manage",
                    "endorsements:update",
                  ])(
                    <ActionButton
                      action={"remove"}
                      tooltip={"Remove associate"}
                      onClick={() =>
                        message.loading({
                          content: "Deleting ...",
                        })
                      }
                    />
                  )}
                </>
              ),
            },
          ]}
          data={associates || []}
          renderLoader={() => <TableLoader items={[1, 1, 1, 1]} />}
          refetch={refetch}
        />
      </div>
    </div>
  );
}
